import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useIntegrations, { getIntegrationData } from 'hooks/useIntegrations';
import { useDispatch, useSelector } from 'react-redux';
import IntegrationsConfig from './config/IntegrationsConfig';
import IntegrationsPageSlider from './IntegrationsPageSlider';
import IntegrationsPageTitle from './IntegrationsPageTitle';
import IntegrationsPageSubtitle from './IntegrationsSubtitle';
import IntegrationsPageContent from './IntegrationsPageContent';
import IntegrationsWelcomeModal from '../IntegrationsWelcomeModal';
import './IntegrationsPage.scss';
import {
  userIntegrated,
  userNotIntegrated
} from '../../../redux/actions/integratedConnection';

export const IntegrationsPageTemplate = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);
  const { email } = useSelector((state) => state.header.user);
  const { integrations: socialIntegrations } = useIntegrations();
  const logEventStub = useCallback(() => {}, []);
  const newLinktreeExperienceEnabled =
    process.env.REACT_APP_NEW_LINKTREE_EXPERIENCE_ENABLED === 'true' ||
    email.endsWith('@linktr.ee') ||
    email.endsWith('@spri.ng') ||
    email.endsWith('@amaze.co');

  let { integrationSlug } = useParams();
  if (integrationSlug === 'linktree' && !newLinktreeExperienceEnabled) {
    integrationSlug = 'linktreeLegacy';
  }
  const integrations = IntegrationsConfig(user);
  const integration = socialIntegrations.find(
    (integr) => integr.name === integrations[integrationSlug]?.title
  );

  const integrationData = integrations[integrationSlug];

  // Check if modal has been shown in this session
  const getModalSessionKey = () => `welcomeModal_${integrationSlug}_shown`;
  const hasModalBeenShown = () =>
    sessionStorage.getItem(getModalSessionKey()) === 'true';

  const [isModalOpen, setIsModalOpen] = React.useState(
    Boolean(integrationData?.welcomeModal?.title) && !hasModalBeenShown()
  );
  const [modalTitle, setModalTitle] = React.useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Mark modal as shown in this session
    sessionStorage.setItem(getModalSessionKey(), 'true');
  };

  useEffect(() => {
    getIntegrationData().then((status) => {
      if (status?.[integrationSlug]) {
        dispatch(userIntegrated());
      } else {
        dispatch(userNotIntegrated());
      }
    });
  }, [dispatch, integrationSlug]);

  return (
    <div className='integrations_page_container'>
      <IntegrationsPageTitle
        title={integrationData?.title}
        iconUrl={integration?.iconUrl || integration?.logo}
      />
      <IntegrationsPageSubtitle subtitle={integrationData?.subtitle} />
      <IntegrationsPageSlider imageUrlArray={integrationData?.bannerImgArray} />
      <IntegrationsPageContent
        integration={integrationData}
        logEvent={logEventStub}
      />
      {integrationData?.welcomeModal?.component && (
        <IntegrationsWelcomeModal
          open={isModalOpen}
          onClose={handleCloseModal}
          title={modalTitle}
          contentComponent={React.createElement(
            integrationData.welcomeModal.component,
            {
              data: integrationData?.modalData,
              setTitle: setModalTitle,
              onClose: handleCloseModal
            }
          )}
        />
      )}
    </div>
  );
};

export default IntegrationsPageTemplate;
